import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import IncomingWebhookForm from './IncomingWebhookForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(IncomingWebhookForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingWebhook/IncomingWebhookForm.container.js